module.exports = __webpack_public_path__ + "static/media/info-circle.8759b5cf.svg";